export default __webpack_public_path__ + "static/media/visibility.34bdf99a.svg";